import type { Match } from 'navigo';

export const RouteGuardOutcomeType = {
  Allow: 'allow',
  Deny: 'deny',
  Redirect: 'redirect',
} as const;

export type RouteGuardOutcome =
  | { readonly type: typeof RouteGuardOutcomeType.Allow }
  /** `onDenied` runs after the router has left the route, on the page the user is returned to. */
  | { readonly type: typeof RouteGuardOutcomeType.Deny; readonly onDenied?: () => void }
  /** `onRedirected` runs after the router has replaced the route with `to`. */
  | { readonly type: typeof RouteGuardOutcomeType.Redirect; readonly to: string; readonly onRedirected?: () => void };

/** Runs before the route handler; the handler runs only on `allow`. */
export type RouteGuard = (match?: Match) => Promise<RouteGuardOutcome>;

export const ALLOW_ROUTE: RouteGuardOutcome = { type: RouteGuardOutcomeType.Allow };
